export default __webpack_public_path__ + "assets/img/welcome_splash2.fcd03232ec5b56ad7a937f7621bb17b4.jpg";